<template>
<div>

  <div class="modal" data-backdrop="static" data-keyboard="false"  id="shopAssistantModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered " role="document">
    <div class="modal-content border border-primary">
      <div  style="background-color:#3399FF" class="modal-header border border-primary text-nowrap">
        <h5 class="modal-title">
          <i  class="fas fa-user-tag mr-3" aria-hidden="true"></i>
          <strong>SHOPPING ASSISTANT </strong></h5>
      </div>
    
      <div class="modal-body" >
        <p><strong>Inserire il codice  </strong></p>
         <form>
          <div class="form-group">          
            <input ref="inputCode" type="number" class="form-control" id="inputCode" placeholder="Codice operatore" v-model="code">          
          </div>
          <button @click="$emit('close')" type="button" class="btn btn-secondary ml-2" data-dismiss="modal">CHIUDI</button>
          
          <button data-dismiss="modal"   type="submit" class="btn btn-primary float-right mr-2">
             <i  class="fas fa-check-circle mr-3" aria-hidden="true"></i>
            APPLICA</button> 
         </form>

      </div>

      
    </div>
  </div>
  </div>
  

</div>

</template>
<script>
export default {
   props : ['rowIndex','data'],
  components: {},
  data() {
    return {
      code   : this.data > 0 ? this.data : 0 ,
          
    };
  },
 

  created: function()
  {
    
    
    this.$nextTick(()  => {    
      $('#shopAssistantModal').modal('show')

        this.$refs.inputCode.focus()
        this.$refs.inputCode.select()
        
        
        
    
    })  
  }, 
  mounted :function() {
    
    $('#shopAssistantModal').on('hidden.bs.modal', (event) =>  {
      this.$emit('update',this.code,this.rowIndex)
      
      
      
    })
     
  },
  methods: 
  {
  }

}
</script>
<style scoped>
small {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
.modal-footer {  
  justify-content: space-between;  
}




</style>


